export { Tabs, Tab } from '@orthly/ui-primitives';
